import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const TableTop = styled(Flex)`
  padding: ${props => props.padding || '5px 20px 0px 20px'};
  border: ${props =>
    props?.border ? 'none' : `1px solid ${COLORS.GREY_T_90}`};
  height: ${props => (props?.customHeight ? props?.customHeight : 'unset')};
  background: ${props => (props.background ? props.background : 'transparent')};
  border-radius: ${props => (props?.radius ? props?.radius : 0)};
  border-bottom: ${props => props.borderbottom && '0px'};
  width: ${props => (props?.width ? props?.width : '100%')};
`
export const ShowingTest = styled('div')`
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  border-left: 1px solid rgba(223, 223, 223, 1);
  margin-right: 20px;
`
